
import config from "../config";
import NavBar from "../website/navbar";
import Footer from "../website/footer";
import { Button } from "../catalyst/button";
import NotFoundContent from "./notFoundContent";


export default function NotFound() {
    return (
      <>
        {/*
          This example requires updating your template:
  
          ```
          <html class="h-full">
          <body class="h-full">
          ```
        */}
        <NavBar>
        </NavBar>
          <NotFoundContent></NotFoundContent>
        <Footer></Footer>
      </>
    )
  }
  